module.exports = __webpack_public_path__ + "img/success.37fdef7.svg";